export class ApplicationAccessLevels {
  static Check = 'check'
  static View = 'view'
  static Edit = 'edit'
  static Duplicate = 'duplicate'
  static Draft = 'draft'
}
